import { reaction } from 'mobx';
import { ClearAuthSessionUseCase } from '~use-cases/ClearAuthSessionUseCase';
import { IAuthSession, UpdateAuthSessionUseCase } from '~use-cases/UpdateAuthSessionUseCase';
import { SetEmailUseCase } from '~use-cases/SetEmailUseCase';
import { AuthSessionRepository } from '~repositories/AuthSessionRepository';
import { GuestRepository } from '~repositories/GuestRepository';
import { AuthSession } from '~domain/entities/AuthSession';

export interface IServiceBusControllerConfig {
    authSessionRepository: AuthSessionRepository;
    authSession: AuthSession;
    guestRepository: GuestRepository;
}

export class ServiceBusController {
    constructor(
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private readonly authSession: AuthSession,
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private readonly careAuthSession: AuthSession,
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private readonly authSessionRepository: AuthSessionRepository,
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private readonly guestRepository: GuestRepository
    ) {
        reaction(() => this.authSession.token, this.tokenChanged);
    }

    public isAuthenticated = () => {
        if (this.authSessionRepository.enableCareConfig) {
            return !!this.careAuthSession.isAuthenticated;
        }

        return !!this.authSession.isAuthenticated;
    };

    public guestEmail = async () => {
        const guestUser = await this.guestRepository.getGuestUser();

        return guestUser.email;
    };

    public getLegacyGuestAuthToken = async () => {
        return this.authSessionRepository.getLegacyAuthToken();
    };

    public getGuestAuthToken = () => {
        return this.authSessionRepository.getGuestAuthToken().access_token;
    };

    public getAccessToken = async () => {
        return this.authSessionRepository.getAccessToken();
    };

    public getUserId = async () => {
        return this.authSessionRepository.getUserId();
    };

    public updateAccessToken = (payload: IAuthSession) => {
        const useCase = new UpdateAuthSessionUseCase(payload);
        useCase.execute();
    };

    public setFormEmail = async ({ email }: { email: string }) => {
        const setEmailUseCase = new SetEmailUseCase(email);
        await setEmailUseCase.execute();
    };

    public signedOut = () => {
        const useCase = new ClearAuthSessionUseCase(this.authSessionRepository);
        void useCase.execute();
    };

    public tokenChanged = () => {
        this.authSessionRepository.storeInCookie();
    };
}
